import {
  FestivalMainNewsContent,
  FestivalMainNewsHeaderMoreButton,
  FestivalMainNewsHeaderWrapper,
  FestivalMainNewsSearchWrapper,
  FestivalMainNewsSwiperItem,
  FestivalMainNewsSwiperText,
  FestivalMainNewsWrapper,
} from "./style";
import { Swiper, SwiperSlide } from "swiper/react";
import GamePagination from "../../../../../../../components/web/GamePaination";
import RabbitFestivalMainNewsList from "./list";
import { useHistory } from "react-router-dom";
import { FestivalSkeletonWhiteBox } from "../../../../style/skeleton";
import { useRabbitFestivalNews } from "../../hooks/use-festival-news";

const RabbitFestivalMainNews = () => {
  const history = useHistory();
  const {
    topNews,
    newsList,
    search,
    setSearch,
    currentPage,
    setCurrentPage,
    getData,
    totalPages,
    isFirst,
    loading,
    searchText,
  } = useRabbitFestivalNews();

  return (
    <FestivalMainNewsWrapper>
      <FestivalMainNewsHeaderWrapper>
        <div className="title">뉴스</div>
        <FestivalMainNewsHeaderMoreButton onClick={() => history.push("/news")}>
          <span>더보기</span>
          <img src="/image-web/rabbit/more.svg" alt="more" />
        </FestivalMainNewsHeaderMoreButton>
      </FestivalMainNewsHeaderWrapper>

      <Swiper
        className="banner-swiper"
        slidesPerView={1.1}
        spaceBetween={8}
        centeredSlides={true}
      >
        {isFirst ? (
          <FestivalSkeletonWhiteBox width="100%" height="210px" />
        ) : (
          topNews.map((item, i) => (
            <SwiperSlide key={i}>
              <FestivalMainNewsSwiperItem
                onClick={() => history.push(`news-detail/${item.id}`)}
              >
                <img src={item.mainImageKey || ""} alt="banner" />
                <FestivalMainNewsSwiperText>
                  {item.title}
                </FestivalMainNewsSwiperText>
              </FestivalMainNewsSwiperItem>
            </SwiperSlide>
          ))
        )}
      </Swiper>
      <FestivalMainNewsContent>
        <FestivalMainNewsSearchWrapper>
          <input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="뉴스를 검색해보세요. "
          />
          <img
            src="/image-web/rank/search.svg"
            alt="search"
            onClick={() => getData()}
          />
        </FestivalMainNewsSearchWrapper>
        <RabbitFestivalMainNewsList
          newsList={newsList}
          loading={loading}
          search={searchText}
        />
        {totalPages > 1 && (
          <GamePagination
            isBlack={true}
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
          />
        )}
      </FestivalMainNewsContent>
    </FestivalMainNewsWrapper>
  );
};

export default RabbitFestivalMainNews;
